export default {"src":"/_next/static/media/search.b29d2b42.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};